import React from "react";
import FetchData from "../../providers/dataProvider";
import { InlineSelectToggleCell } from "./SizeSelectField";
import urls from "../../constants";

const buildOverrideParams = (configuration = [], rowVariants = [], productConfig) => {
    const getValue = (attributeId) =>
        configuration.find((x) => x.attributeId === attributeId)?.valueName || "";
    const getRowVal = (matcher) =>
        rowVariants.find((v) => matcher((v?.variantName || "").toLowerCase()))?.variantValue || ""

    return {
        DuctWidth: getRowVal((n) => n.includes("width")),
        DuctHeight: getRowVal((n) => n.includes("height")),
        OrderQuantity: getRowVal((n) => n.includes("qty") || n.includes("quantity")),
        Model: productConfig?.productName?.productName,
        ModelId: productConfig?.productName?.productId,
        VelocityRating: getValue(urls.VELOCITY_RATING),
        PressureRating: getValue(urls.PRESSURE_RATING),
        TemperatureRating: getValue(urls.CFSD_TEMPERATURE_CLASS),
        MountingOrientation: getValue(urls.CFSD_MOUNTING_ORIENTATION),
        MaterialOfConstruction: getValue(urls.CEILING_MATERIAL),
        TransitionType: getRowVal((n) => n.includes("transition")),
        Sizing: getValue(urls.SIZING),
        ActuatorMake: getValue(urls.CFSD_ACTUATOR_MAKE),
        ActuatorVoltage: getValue(urls.CFSD_ACTUATOR_VOLTAGE),
        ActuatorOperation: getValue(urls.CFSD_ACTUATOR_OPERATION) || "None"
    };
};

export const ActuatorOverrideCell = ({
    isOverrideActive,
    configuration,
    rowVariants,
    productConfig,
    actuatorModelValue,
    onActuatorModelChange,
}) => {
    const params = buildOverrideParams(configuration, rowVariants, productConfig);
    params.skip = !isOverrideActive;

    const { data, loading } = FetchData("actuatoroverride", params);

    const rawList = Array.isArray(data) ? data : Array.isArray(data?.data) ? data.data : [];

    const options = rawList
        .map((item) => {
            const modelVal = item?.actuatorModel ?? item?.model ?? item?.value ?? item?.label;
            const cost = item?.actuatorCost ?? item?.cost ?? 0;
            return modelVal ? { label: modelVal, value: modelVal, cost } : null;
        })
        .filter(Boolean);

    if (!isOverrideActive) {
        return <span
            className="size-readonly-text"
            style={{ fontWeight: 400 }}
        >{actuatorModelValue || ""}</span>;
    }

    return (
        <InlineSelectToggleCell
            value={actuatorModelValue}
            placeholder={loading ? "Loading..." : "Select"}
            options={options}
            loading={loading}
            disabled={options.length === 0}
            onChange={(option) => {
                const matched = options.find((o) => o.value === option?.value);
                onActuatorModelChange(option, matched?.cost);
            }}
        />
    );
};